import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly cookies with every request
});

export const api = {
  // public
  stats: () => http.get("/stats").then((r) => r.data),
  properties: (params = {}) => http.get("/properties", { params }).then((r) => r.data),
  property: (id) => http.get(`/properties/${id}`).then((r) => r.data),
  trackShare: (id, platform) => http.post(`/properties/${id}/share-tracked`, { platform }).then((r) => r.data).catch(() => null),
  submitContact: (data) => http.post("/contacts", data).then((r) => r.data),
  // auth
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  // admin
  createProperty: (data) => http.post("/admin/properties", data).then((r) => r.data),
  updateProperty: (id, data) => http.put(`/admin/properties/${id}`, data).then((r) => r.data),
  deleteProperty: (id) => http.delete(`/admin/properties/${id}`).then((r) => r.data),
  setFeaturedOrder: (orderedIds) =>
    http.put("/admin/properties/featured/order", { ordered_ids: orderedIds }).then((r) => r.data),
  uploadImage: (file) => {
    const form = new FormData();
    form.append("file", file);
    return http.post("/admin/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  uploadVideo: (file, onUploadProgress) => {
    const form = new FormData();
    form.append("file", file);
    return http.post("/admin/upload-video", form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
      timeout: 5 * 60 * 1000,
    }).then((r) => r.data);
  },
  listContacts: () => http.get("/admin/contacts").then((r) => r.data),
  markContactRead: (id) => http.patch(`/admin/contacts/${id}/read`).then((r) => r.data),
  deleteContact: (id) => http.delete(`/admin/contacts/${id}`).then((r) => r.data),
  updateStats: (data) => http.put("/admin/stats", data).then((r) => r.data),
  runBackupNow: () => http.post("/admin/backup/run").then((r) => r.data),
  downloadBackup: () => http.get("/admin/backup/download", { responseType: "blob" }),
  // support
  supportChat: (data) => http.post("/support/chat", data).then((r) => r.data),
  submitSupportContact: (data) => http.post("/support/contact", data).then((r) => r.data),
  listSupportMessages: () => http.get("/admin/support/messages").then((r) => r.data),
  markSupportRead: (id) => http.patch(`/admin/support/messages/${id}/read`).then((r) => r.data),
  deleteSupportMessage: (id) => http.delete(`/admin/support/messages/${id}`).then((r) => r.data),
  // analytics
  propertyStats: (id) => http.get(`/admin/properties/${id}/stats`).then((r) => r.data),
  allPropertiesStats: () => http.get("/admin/properties-stats").then((r) => r.data),
  regeocodeProperty: (id) => http.post(`/admin/properties/${id}/geocode`).then((r) => r.data),
  // visit-request tracker (public, fire-and-forget)
  logVisitRequest: (id) => http.post(`/properties/${id}/visit-request`).then((r) => r.data),
  // estimation (lead capture)
  submitEstimation: (data) => http.post("/estimations", data).then((r) => r.data),
  listEstimations: (params = {}) => http.get("/admin/estimations", { params }).then((r) => r.data),
  updateEstimationStatus: (id, status) =>
    http.patch(`/admin/estimations/${id}`, { status }).then((r) => r.data),
  deleteEstimation: (id) => http.delete(`/admin/estimations/${id}`).then((r) => r.data),
};

export default http;
